export default "__VITE_ASSET__CAwk6d2K__"